import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import i18n from './tools/i18n'
import router from './router'
import store from './store'
import commonfun from './commonfun'
import './plugins/element.js'
import baseUrl from './utils/base'
import * as fundebug from 'fundebug-javascript'
import fundebugVue from 'fundebug-vue'
if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'pre') {
  require('fundebug-revideo')
  fundebug.init({
    apikey: '1a20e3cfcda84092e917ac50f899f1f35e4ea627250d8d51d59753c1b327d3a4',
    appversion: baseUrl.Version,
    releasestage: process.env.NODE_ENV,
    setHttpBody: true,
    httpTimeout: 10000,
    // 过滤400错误 图片加载错误
    filters: [{
      res: {
        status: /^400$/
      }
    }, {
      res: {
        status: /^401$/
      }
    }, {
      res: {
        status: /^403$/
      }
    }, {
      target: {
        tagName: /^IMG$/,
        status: 'inexistence'
      }
    }],
    // 不监控资源加载
    silentResource: true,
    silentConsole: true,
    silentVideo: false
  })
  fundebugVue(fundebug, Vue)
}

Vue.config.productionTip = false
Vue.prototype.$commonfun = commonfun// 引入一个全局都可以掉用的方法

// 导航守卫
router.beforeEach((to, from, next) => {
  var lang = ''
  switch (window.localStorage.getItem('lang')) {
    case 'JP':
      lang = 'jp'
      break
    case 'CHS':
      lang = 'zh'
      break
    case 'ENG':
      lang = 'en'
      break
    default:
      lang = 'zh'
  }
  document.title = i18n.messages[lang].LanguageLib.SYSTEM_NAME
  // 如果未登录跳转到登录页
  if (to.path === '/login') {
    // commonfun.localStorage.clearall()
    commonfun.localStorage.removeitem('routekey')
    commonfun.localStorage.removeitem('ownerId')
    commonfun.localStorage.removeitem('ownerCode')
    commonfun.localStorage.removeitem('userId')
    commonfun.localStorage.removeitem('sid')
    commonfun.localStorage.removeitem('token')
    commonfun.localStorage.removeitem('userName')
    commonfun.localStorage.removeitem('ownerName')
    commonfun.localStorage.removeitem('OwnerLanguage')
    commonfun.localStorage.removeitem('qyuser')
    commonfun.localStorage.removeitem('portrait')
    commonfun.localStorage.removeitem('loginstatus')
    commonfun.localStorage.removeitem('title')
    commonfun.localStorage.removeitem('topath')
    commonfun.localStorage.removeitem('keys')
    window.localStorage.setItem('toquery', JSON.stringify(to.query))
    window.localStorage.setItem('topath', to.path)
    next(true)
  } else {
    if (window.localStorage.getItem('loginstatus') === 'true') {
      window.localStorage.setItem('toquery', JSON.stringify(to.query))
      window.localStorage.setItem('topath', to.path)
      next(true)
    } else {
      next('/login')
    }
  }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
